<div *ngIf="modalIsVisible" class="modal-overlay">

    <form class="modal" [formGroup]="profileForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="close-btn"><span
            class="my-color-blue">{{ '__REQUESTS_CANCELATION_NOTE__' | translate }}</span><img
            (click)="modalClose()" src="assets/img/close-btn.svg"/></div>

        <span class="reason" *ngIf="currentNote !== null">{{ currentNote }}</span>
        <textarea *ngIf="currentNote === null" formControlName="reason" rows="10" cols="20"
                  placeholder="{{'__REQUESTS_CANCELATION_REASON__' | translate}}"
                  [@headShake]="profileForm.controls['reason'].invalid && animationState"></textarea>

        <button *ngIf="currentNote === null" type="submit"
                class="submit-button btn-rounded-blue primary-bg-color">
            <span>{{ '__REQUESTS_CANCELATION_SUMBIT__' | translate }}</span></button>
    </form>
</div>
<div class="shadow-container">
    <div class="appoints-container" *ngIf="appointmentsList">
        <div class="table-header" [ngClass]=" {'hasPhotos': hasCoachPhotos}">
            <div>{{ '__COACH_APPOINT_COACH__' | translate }}</div>
            <div>{{ '__COACH_APPOINT_DETAILS__' | translate }}</div>
            <div style="text-align: center">{{ '__COACH_APPOINT_STATUS__' | translate }}</div>
            <div>{{ '__TYPE__' | translate }}</div>
            <div class="table-header-actions">
                <div>{{ '__JOIN_SESSION__' | translate }}</div>
                <div>{{ '__COACH_APPOINT_YOUR_FEEDBACK__' | translate }}</div>
            </div>
        </div>
        <div class="appoint" [ngClass]=" {'hasPhotos': hasCoachPhotos}"
             *ngFor="let item of appointmentsList | filter : 'isPassed' : false : isShowCompleted ? 'ignore' : 'equals'">

            <div class="name my-color-blue">
                <img *ngIf="item.coach.file === null" src="assets/img/user-blue.svg"/>
                <img *ngIf="item.coach.file !== null" [src]="item.coach.file.url"/>
                <div>{{ item.coach.full_name }}</div>
            </div>

            <div class="session-details">
                <div class="date">
                    <span>{{ '__COACH_APPOINT_DATE__' | translate }}</span>{{ item.start_at | amDateFormat: 'dddd Do MMMM, y' }}
                </div>
                <div class="time">
                    <span>{{ '__COACH_APPOINT_TIME__' | translate }}</span>{{ item.start_at | date : 'HH:mm' }}
                    - {{ item.end_at | date : 'HH:mm' }}
                </div>
                <div class="title"><span>{{ '__COACH_APPOINT_TITLE__' | translate }}</span>{{ item.title }}</div>
            </div>
            <div class="status-container">
                <span *ngIf="item.status === 'completed'">{{ '__STATUS_APPOINT_COMPLETED__' | translate }}</span>
                <span *ngIf="item.status === 'confirmed'">{{ '__STATUS_APPOINT_CONFIRM__' | translate }}</span>
                <span
                    *ngIf="item.status === 'pending'">{{ '__STATUS_APPOINT_AWAIT_CONFIRM__' | translate }}</span>
                <span *ngIf="item.status === 'cancelled'">{{ '__STATUS_APPOINT_CANCELLED__' | translate }}</span>
                <span *ngIf="item.status === 'rejected'">{{ '__STATUS_APPOINT_REJECTED__' | translate }}</span>
                <div class="round-status"
                     [ngClass]=" {'green': item.status === 'confirmed' || item.status === 'completed', 'yellow': item.status === 'pending', 'red': ( item.status === 'cancelled' || item.status === 'rejected')}">
                    <img src="assets/img/icon-await-confirm.svg" *ngIf="item.status === 'pending'"
                         [ngClass]=" {'yellow': item.status === 'pending' }"/>
                    <img src="assets/img/icon-confirm-white.svg"
                         *ngIf="item.status === 'confirmed' || item.status === 'completed'"/>
                    <img src="assets/img/icon-cancel.svg"
                         *ngIf="item.status === 'cancelled' || item.status === 'rejected'"/>
                </div>
            </div>
            <div class="type-container">
                <span>{{ getTitleByCode(item.meeting_type)  | translate }}</span>
            </div>
            <div class="button-container">
                <div>
                    <button class="join-session" [ngClass]="{active: joinSessionButtonActive(item)}"
                            (click)="joinSession(item)"
                            *ngIf="item.status === 'confirmed' && item.meeting_type === 'video'"
                            [disabled]="!joinSessionButtonActive(item)">
                        <img src="assets/img/join-session.svg"/>
                        <span>{{ '__BUTTON_JOIN_SESSION__' | translate }}</span>
                    </button>
                    <button class="join-session face2face" [ngClass]="{active: joinSessionButtonActive(item)}"
                            *ngIf="item.status === 'confirmed' && item.meeting_type === 'face2face'"
                            [disabled]="!joinSessionButtonActive(item)">
                        <img src="assets/img/face2face.svg"/>
                        <span>{{ '__BUTTON_JOIN_SESSION__' | translate }}</span>
                    </button>
                    <button *ngIf="item.meeting_type === 'face2face' && item.status ==='pending'" class="join-session">
                        <img src="assets/img/face2face.svg"/>
                        <span>{{ '__BUTTON_JOIN_SESSION__' | translate }}</span>
                    </button>
                    <button *ngIf="item.meeting_type !== 'face2face' && item.status ==='pending'" class="join-session">
                        <img src="assets/img/join-session.svg"/>
                        <span>{{ '__BUTTON_JOIN_SESSION__' | translate }}</span>
                    </button>
                </div>
                <div>
                    <button class="cancel-session" (click)="cancelAppointment(item)"
                            *ngIf='item.status === "confirmed" || item.status === "pending" '>
                        <img src="assets/img/cancel-session.svg"/>
                        <span>{{ '__SC_FORM_WARNING_CANCEL__' | translate }}</span>
                    </button>
                    <button class="cancel-session" (click)="viewNote(item.reason)"
                            *ngIf='item.status === "cancelled" || item.status === "rejected" '>
                        <img src="assets/img/icon-note-cancel.svg"/>
                        <span>{{ '__BUTTON_VIEW_NOTE__' | translate }}</span>
                    </button>
                    <button class="feedback" (click)="openFeedback(item)"
                            *ngIf='item.status === "completed" && !item.feedback'>
                        <img src="assets/img/icon-feedback.svg"/>
                    </button>
                </div>
            </div>
        </div>
    </div>


    <div class="appoints-container" *ngIf="!appointmentsList">
        <div class="appoint" *ngFor="let width of [1,2,3]">
            <div class="name my-color-blue">
                <ion-skeleton-text animated></ion-skeleton-text>
                <ion-skeleton-text animated style="width: 10rem; height: 1.5rem"></ion-skeleton-text>
            </div>
            <div class="session-details">
                <div class="date">
                    <ion-skeleton-text animated style="width: 13rem; height: 1rem"></ion-skeleton-text>
                </div>
                <div class="time">
                    <ion-skeleton-text animated style="width: 13rem; height: 1rem"></ion-skeleton-text>
                </div>
                <div class="title">
                    <ion-skeleton-text animated style="width: 13rem; height: 1rem"></ion-skeleton-text>
                </div>
            </div>
            <div class="status-container">
                <ion-skeleton-text animated style="height: 1rem; width: 5rem"></ion-skeleton-text>
                <div class="round-status">
                    <ion-skeleton-text animated></ion-skeleton-text>
                </div>
            </div>
            <div class="status-container">
                <ion-skeleton-text animated style="height: 1rem; width: 7rem"></ion-skeleton-text>
                <ion-skeleton-text animated style="height: 1rem; width: 7rem"></ion-skeleton-text>
            </div>
            <div class="button-container">
                <ion-skeleton-text animated style="height: 5rem; width: 7rem"></ion-skeleton-text>
            </div>
        </div>
    </div>
</div>
